import React from 'react'

const ModuleDisplayRichText = ({ value }) => {
    return (
        <div>
            {<div className="html" dangerouslySetInnerHTML={{ __html: value }} />}
        </div>
    )
}

export default ModuleDisplayRichText